import { Outages } from 'containers/Outages'

export default Outages
